module.exports = __webpack_public_path__ + "static/media/logo-white.954c2008.png";